import { useLang } from "../hooks/useLanguage";
import { Reveal } from "./Reveal";

const Solutions = () => {
  const { t } = useLang();
  return (
    <section id="solutions" className="bg-white text-[#202020] py-24 md:py-32" data-testid="solutions-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <Reveal className="max-w-3xl">
          <p className="label-caps">{t.UI.solutionsLabel}</p>
          <h2 className="mt-4 font-serif-lux font-light text-[clamp(2rem,4.5vw,3.4rem)] leading-[1.08] tracking-tight">
            {t.UI.solutionsTitle}
          </h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-2 xl:grid-cols-4 gap-px bg-[#141414]/10 border hairline-light">
          {t.SOLUTIONS.map((s, i) => (
            <Reveal key={s.n} delay={(i % 4) * 0.07} className="h-full">
              <article
                className={`group h-full p-8 flex flex-col transition-[background-color,transform] duration-500 hover:-translate-y-1 ${
                  i === 0 ? "bg-[#141414] text-ivory" : "bg-white hover:bg-[#F4F0E9]"
                }`}
                data-testid={`solution-card-${s.n}`}
              >
                <span className="latin-text font-serif-lux text-5xl font-light text-champagne">{s.n}</span>
                <h3 className="mt-8 font-serif-lux text-2xl font-medium leading-snug">{s.name}</h3>
                <p className={`mt-3 text-sm leading-relaxed flex-1 ${i === 0 ? "text-ivory/60" : "text-smoke"}`}>
                  {s.text}
                </p>
                <span
                  className={`mt-8 block h-px w-full ${
                    i === 0 ? "bg-champagne/50" : "bg-[#141414]/10 group-hover:bg-champagne/60"
                  } transition-[background-color] duration-500`}
                />
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-8">
          <p className="text-xs text-smoke tracking-wide" data-testid="solutions-disclaimer">
            {t.SOLUTIONS_DISCLAIMER}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Solutions;
